import { SVGProps } from "react"

export const LinkedInIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 2C2.67157 2 2 2.67157 2 3.5V12.5C2 13.3284 2.67157 14 3.5 14H12.5C13.3284 14 14 13.3284 14 12.5V3.5C14 2.67157 13.3284 2 12.5 2H3.5ZM4.74556 5.5C5.21057 5.5 5.5 5.16665 5.5 4.75006C5.49133 4.3241 5.21057 4 4.75438 4C4.29824 4 4 4.3241 4 4.75006C4 5.16665 4.28937 5.5 4.73687 5.5H4.74556ZM5.5 6.5V12H4V6.5H5.5ZM7 12H8.5V8.89479C8.5 8.89479 8.60415 7.78962 9.55208 7.78962C10.5 7.78962 10.5 9.02275 10.5 9.02275V12H12V8.8133C12 7.13837 11.25 6.5025 10.125 6.5025C9 6.5025 8.5 7.27778 8.5 7.27778V6.5025H7.00005C7.02383 7.01418 7 12 7 12Z"
      fill="currentColor"
    />
  </svg>
)

export const XIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.59961 2H5.79961L8.78698 6.16842L12.3996 2H13.9996L9.51119 7.17895L14.3996 14H10.1996L7.21224 9.83158L3.59961 14H1.99961L6.48803 8.82105L1.59961 2ZM10.816 12.8L3.93596 3.2H5.18326L12.0633 12.8H10.816Z"
      fill="currentColor"
    />
  </svg>
)

export const ExternalLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="8"
    height="8"
    fill="none"
    viewBox="0 0 8 8"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.88 6.924V1.632H.612L1.8.456l5.268.012v5.28zm-5.364-.96L5.928.54l1.068 1.056L1.572 7.02z"
    />
  </svg>
)

export const ArrowDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.497844 3.886L3.92984 7.307L7.33984 3.897L7.33984 5.426L3.91884 8.836L0.497844 5.415L0.497844 3.886ZM3.26984 -1.77905e-07L4.57884 -1.20687e-07L4.57884 8.055L3.26984 8.055L3.26984 -1.77905e-07Z"
      fill="currentColor"
    />
  </svg>
)

export const CalendarScheduleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.83329 2.50001V0.833344H7.49996V2.50001H12.5V0.833344H14.1666V2.50001H17.5C17.9602 2.50001 18.3333 2.87311 18.3333 3.33334V7.50001H16.6666V4.16668H14.1666V5.83334H12.5V4.16668H7.49996V5.83334H5.83329V4.16668H3.33329V15.8333H8.33329V17.5H2.49996C2.03973 17.5 1.66663 17.1269 1.66663 16.6667V3.33334C1.66663 2.87311 2.03973 2.50001 2.49996 2.50001H5.83329ZM14.1666 10C12.3257 10 10.8333 11.4924 10.8333 13.3333C10.8333 15.1743 12.3257 16.6667 14.1666 16.6667C16.0075 16.6667 17.5 15.1743 17.5 13.3333C17.5 11.4924 16.0075 10 14.1666 10ZM9.16663 13.3333C9.16663 10.5719 11.4052 8.33334 14.1666 8.33334C16.928 8.33334 19.1666 10.5719 19.1666 13.3333C19.1666 16.0948 16.928 18.3333 14.1666 18.3333C11.4052 18.3333 9.16663 16.0948 9.16663 13.3333ZM13.3333 10.8333V13.6785L15.244 15.5893L16.4225 14.4108L15 12.9882V10.8333H13.3333Z"
      fill="currentColor"
    />
  </svg>
)

export const EarthIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.19587 5.37773C4.04247 6.57622 3.33329 8.20529 3.33329 9.99999C3.33329 13.6819 6.31806 16.6667 9.99996 16.6667C10.9006 16.6667 11.7596 16.4881 12.5434 16.1643C12.6392 15.5389 12.429 14.9388 12.343 14.7288C12.1516 14.2625 11.52 13.4652 10.4657 12.359C10.1843 12.0632 10.2024 11.8362 10.303 11.1619L10.3145 11.0857C10.3829 10.6238 10.4975 10.3507 12.0518 10.104C12.8414 9.97882 13.049 10.2944 13.3369 10.7314C13.3687 10.7798 13.4005 10.8273 13.4331 10.8749C13.7065 11.2747 13.9091 11.3662 14.2151 11.5053C14.3522 11.5675 14.5233 11.6459 14.7525 11.7762C15.2959 12.0867 15.2959 12.4372 15.2959 13.206V13.2932C15.2959 13.6195 15.264 13.906 15.2138 14.1549C16.1231 13.0154 16.6666 11.5712 16.6666 9.99999C16.6666 7.25073 15.0025 4.89016 12.6265 3.87067C12.1655 4.18176 11.5331 4.62271 11.3125 4.92499C11.1996 5.07947 11.0401 5.86804 10.5214 5.93312C10.3855 5.95018 10.2031 5.93823 10.01 5.9258C9.49204 5.89214 8.78346 5.84671 8.55663 6.46245C8.41263 6.85266 8.38729 7.91203 8.85321 8.46191C8.92779 8.54974 8.94221 8.71224 8.89154 8.89457C8.82496 9.13399 8.69046 9.27966 8.64854 9.30974C8.56821 9.26357 8.40796 9.07757 8.29944 8.95099C8.03791 8.64707 7.71167 8.2686 7.28993 8.15146C7.13658 8.10901 6.96801 8.07388 6.80453 8.03946C6.34696 7.94355 5.82865 7.83444 5.70823 7.57751C5.62031 7.38932 5.62069 7.13016 5.62103 6.85636C5.62103 6.50932 5.62103 6.1169 5.45103 5.73546C5.38534 5.58783 5.29737 5.47037 5.19587 5.37773ZM9.99996 18.3333C5.39758 18.3333 1.66663 14.6023 1.66663 9.99999C1.66663 5.39761 5.39758 1.66666 9.99996 1.66666C14.6023 1.66666 18.3333 5.39761 18.3333 9.99999C18.3333 14.6023 14.6023 18.3333 9.99996 18.3333Z"
      fill="currentColor"
    />
  </svg>
)

export const ErrorAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 4.687v6.626L11.313 16H4.687L0 11.313V4.687L4.687 0h6.626zM8 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.8-1.2h1.6V3.7H7.2z"
    />
  </svg>
)
